<template>
  <div v-if="!hidden" :class="{opened: !hidden, opaque: isOpaque}" class="generic-modal-container">

    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          <slot name="header"></slot>
        </h3>
        <div class="mt-2 max-w-xl text-sm text-gray-500">
          <slot></slot>
        </div>
        <div class="mt-5">
          <slot name="buttons"></slot>
        </div>
      </div>
    </div>

    <slot></slot>

  </div>
</template>

<script>
export default {
  props: ['name', 'isOpaque'],
  data() {
    return {
      hidden: true
    }
  },
  computed: {},
  methods: {
    closeModal() {
      this.hidden = true;
    },
    openModal() {
      this.hidden = false;
    }
  },
  mounted() {
    var that = this;
    var key = '';

    if (this.name) {
      key = '-' + this.name;
    }
    eventBus.$on('modal-open' + key, function (closure) {
      that.openModal();
    });
    eventBus.$on('modal-close' + key, function (closure) {
      that.closeModal();
    });
  }
}
</script>

<style lang="scss" scoped>
.generic-modal-container {
  display: none;

  &.opened {
    background-color: #fff;
    position: absolute;
    min-height: 100vh;
    width: 100vw;
    z-index: 100000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    @include desktop() {
      background-color: rgba(255, 255, 255, 0.6);
      &.opaque {
        background-color: rgba(255, 255, 255, 1);
      }
    }
  }

}
</style>
